module.exports = __webpack_public_path__ + "static/media/MTL_SKILL2.4ae46be0.png";